<p-toast></p-toast>
<div>
    <div class="card dashboardTable">
        <p-table #subsidyToVendorPFMSReportTable [value]="subsidyToVendorPFMSReportModel" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
            'Srno',
            'Lot_No', 
            'dateofExport',
            'Sum_of_PFMS_Export', 
            'TargetDays', 
            'PendingCompletedDays', 
            'NoOfTimesExported', 
            'Sum_of_Successfull_Records', 
            'Sum_of_Pending_Records', 
            'Sum_of_Failed_Records', 
            'Sum_of_Bank_Transfer_Successfull_Records', 
            'block', 
            'district', 
            'No_of_Record', 
            'remarks', 
            'status',
            'Status_Ar', 
            'village', 
            'lotNoForSorting', 
            'FinYear', 
            'No_of_Pending_Records', 
            'No_of_Failed_Records', 
            'No_of_Successfull_Records', 
            'No_of_Bank_Transfer_Successfull_Records',
            'Caste']" [paginator]="true" responsiveLayout="scroll" [rowHover]="true" dataKey="Lot_No"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
            [tableStyle]="{'max-width': '80rem'}" sortField="lotNoForSorting" [sortOrder]="1">
            <ng-template pTemplate="caption">
                <div class="grid d-flex align-items-center justify-content-end"
                    [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                    <!-- Left side -->
                    <div class="col-6 md:col-5">
                        <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{
                            'SUBSIDY_TO_VENDOR_PFMS_REPORTS' |
                            translate}}
                        </h5>
                    </div>
                    <!-- Middle section for buttons -->
                    <div class="col-6 md:col-3 d-flex justify-content-center">
                        <button (click)="menu.toggle($event)" pButton pRipple label="{{'' | translate}}"
                            icon="pi pi-download" class="p-button-help"></button>
                        <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
                        <button (click)="refreshTable()" pButton pRipple label="{{''| translate}}" icon="pi pi-refresh"
                            class="p-button-info ml-3"></button>
                    </div>
                    <!-- Right side for search -->
                    <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="subsidyToVendorPFMSReportTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH' | translate}}" />
                        </span>
                        <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="exportMenu"></p-menu> -->
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <!-- <th pSortableColumn="Srno">{{'S_NO'| translate}}
                            <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                            <p-sortIcon field="Srno"></p-sortIcon>
                        </th> -->
                    <th pSortableColumn="lotNoForSorting">{{'FILE_NO'| translate}}
                        <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                        <p-sortIcon field="lotNoForSorting"></p-sortIcon>
                    </th>
                    <th pSortableColumn="dateofExport">{{'DATE_OF_EXPORT'| translate}}
                        <p-columnFilter type="text" field="dateofExport" display="menu"></p-columnFilter>
                        <p-sortIcon field="dateofExport"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Total_Sum">{{'TOTAL_SUM'| translate}}
                        <p-columnFilter type="text" field="Total_Sum" display="menu"></p-columnFilter>
                        <p-sortIcon field="Total_Sum"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_PFMS_Export">{{'SUM_OF_PFMS_EXPORT'| translate}}
                        <p-columnFilter type="text" field="Sum_of_PFMS_Export" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_PFMS_Export"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TargetDays">{{'TARGET_DAYS' | translate}}
                        <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="TargetDays"></p-sortIcon>
                    </th>
                    <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                        <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                        <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="NoOfTimesExported">{{'NO_OF_TIMES_EXPORTED' | translate}}
                        <p-columnFilter type="text" field="NoOfTimesExported" display="menu"></p-columnFilter>
                        <p-sortIcon field="NoOfTimesExported"></p-sortIcon>
                    </th>

                    <th pSortableColumn="Sum_of_Centre_Share_AllRec">{{'SUM_OF_CENTRE_SHARE_(ALL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share_AllRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share_AllRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_State_Share_AllRec">{{'SUM_OF_STATE_SHARE_(ALL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share_AllRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share_AllRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TopUp_All">{{'SUM_OF_TOP_UP_(ALL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="TopUp_All" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="TopUp_All"></p-sortIcon>
                    </th>


                    <th pSortableColumn="SumOfCenterShare_Success">{{'SUM_OF_CENTRE_SHARE_(SUCCESSFUL_RECORDS)'|
                        translate}}
                        <p-columnFilter type="text" field="SumOfCenterShare_Success" display="menu"></p-columnFilter>
                        <p-sortIcon field="SumOfCenterShare_Success"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SumOfStateShare_Success">{{'SUM_OF_STATE_SHARE_(SUCCESSFUL_RECORDS)'|
                        translate}}
                        <p-columnFilter type="text" field="SumOfStateShare_Success" display="menu"></p-columnFilter>
                        <p-sortIcon field="SumOfStateShare_Success"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TopUp_Success">{{'SUM_OF_TOP_UP_(SUCCESSFUL_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="TopUp_Success" display="menu"></p-columnFilter>
                        <p-sortIcon field="TopUp_Success"></p-sortIcon>
                    </th>


                    <th *ngIf="!isCAOLogin" pSortableColumn="Sum_of_Centre_Share_PenRec">
                        {{'SUM_OF_CENTRE_SHARE_(PENDING_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share_PenRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share_PenRec"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="Sum_of_State_Share_PenRec">
                        {{'SUM_OF_STATE_SHARE_(PENDING_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share_PenRec" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share_PenRec"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="TopUp_Pend">{{'SUM_OF_TOP_UP_(PENDING_RECORDS)'|
                        translate}}
                        <p-columnFilter type="text" field="TopUp_Pend" display="menu"></p-columnFilter>
                        <p-sortIcon field="TopUp_Pend"></p-sortIcon>
                    </th>



                    <th pSortableColumn="Sum_of_Centre_Share_FailedRec">{{'SUM_OF_CENTRE_SHARE_(FAILED_RECORDS)'|
                        translate}}
                        <p-columnFilter type="text" field="Sum_of_Centre_Share_FailedRec"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Centre_Share_FailedRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_State_Share_FailedRec">{{'SUM_OF_STATE_SHARE_(FAILED_RECORDS)'|
                        translate}}
                        <p-columnFilter type="text" field="Sum_of_State_Share_FailedRec"
                            display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_State_Share_FailedRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="TopUp_Failed">{{'SUM_OF_TOP_UP_(FAILED_RECORDS)'| translate}}
                        <p-columnFilter type="text" field="TopUp_Failed" display="menu"></p-columnFilter>
                        <p-sortIcon field="TopUp_Failed"></p-sortIcon>
                    </th>

                    <th pSortableColumn="No_of_Record">{{'NO_OF_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Record" display="menu"></p-columnFilter>
                        <p-sortIcon field="No_of_Record"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_Successfull_Records">{{'NO_OF_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Successfull_Records"></p-sortIcon>
                    </th>
                    <th *ngIf="!isCAOLogin" pSortableColumn="NoOfPendingRecords">{{'NO_OF_PENDING_RECORDS'| translate}}
                        <p-columnFilter type="text" field="NoOfPendingRecords" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="NoOfPendingRecords"></p-sortIcon>
                    </th>
                    <th pSortableColumn="No_of_Failed_Records">{{'NO_OF_FAILED_RECORDS'| translate}}
                        <p-columnFilter type="text" field="No_of_Failed_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="No_of_Failed_Records"></p-sortIcon>
                    </th>


                    <th pSortableColumn="Sum_of_Successfull_Records">{{'SUM_OF_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="SumOfPendingRecords">{{'SUM_OF_PENDING_RECORDS'| translate}}
                        <p-columnFilter type="text" field="SumOfPendingRecords" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="SumOfPendingRecords"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Failed_Records">{{'SUM_OF_FAILED_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Failed_Records" display="menu"></p-columnFilter>
                        <p-sortIcon field="Sum_of_Failed_Records"></p-sortIcon>
                    </th>

                    <th pSortableColumn="NoOfSuccessfullBankRec">{{'NO_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'|
                        translate}}
                        <p-columnFilter type="text" field="NoOfSuccessfullBankRec" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="NoOfSuccessfullBankRec"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Sum_of_Bank_Transfer_Successfull_Records">
                        {{'SUM_OF_BANK_TRANSFER_SUCCESSFULL_RECORDS'| translate}}
                        <p-columnFilter type="text" field="Sum_of_Bank_Transfer_Successfull_Records" display="menu">
                        </p-columnFilter>
                        <p-sortIcon field="Sum_of_Bank_Transfer_Successfull_Records"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                        <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                        <p-sortIcon field="FinYear"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                    <!-- <td>{{product.Srno}}</td> -->
                    <td><button (click)="pmfsExport(product.Lot_No, '')" pButton pRipple type="button"
                            label="{{product.Lot_No}}" class="p-button-text"></button></td>
                    <td>{{product.dateofExport}}</td>
                    <td>{{product.Total_Sum}}</td>
                    <td>{{product.Sum_of_PFMS_Export}}</td>
                    <td>{{product.TargetDays}}</td>
                    <td>{{product.PendingCompletedDays}}</td>
                    <td *ngIf="!isCAOLogin">{{product.NoOfTimesExported}}</td>

                    <td>{{product.Sum_of_Centre_Share_AllRec}}</td>
                    <td>{{product.Sum_of_State_Share_AllRec}}</td>
                    <td>{{product?.TopUp_All}}</td>

                    <td>{{product.SumOfCenterShare_Success}}</td>
                    <td>{{product.SumOfStateShare_Success}}</td>
                    <td>{{product.TopUp_Success}}</td>

                    <td *ngIf="!isCAOLogin">{{product.Sum_of_Centre_Share_PenRec}}</td>
                    <td *ngIf="!isCAOLogin">{{product.Sum_of_State_Share_PenRec}}</td>
                    <td *ngIf="!isCAOLogin">{{product.TopUp_Pend}}</td>

                    <td>{{product.Sum_of_Centre_Share_FailedRec}}</td>
                    <td>{{product.Sum_of_State_Share_FailedRec}}</td>
                    <td>{{product.TopUp_Failed}}</td>

                    <td>{{product.No_of_Record}}</td>
                    <td>{{product?.No_of_Successfull_Records}}</td>
                    <td *ngIf="!isCAOLogin">{{product?.NoOfPendingRecords}}</td>
                    <td>{{product?.No_of_Failed_Records}}</td>

                    <td><button (click)="pmfsExport(product.Lot_No, 'S')" pButton pRipple type="button"
                            label="{{product?.Sum_of_Successfull_Records}}" class="p-button-text"></button></td>
                    <td><button (click)="pmfsExport(product.Lot_No, 'P')" pButton pRipple type="button"
                            label="{{product?.SumOfPendingRecords}}" class="p-button-text"></button></td>
                    <td><button (click)="pmfsExport(product.Lot_No, 'F')" pButton pRipple type="button"
                            label="{{product?.Sum_of_Failed_Records}}" class="p-button-text"></button></td>

                    <td>{{product?.NoOfSuccessfullBankRec}}</td>
                    <td>{{product.Sum_of_Bank_Transfer_Successfull_Records}}</td>
                    <td>{{product.FinYear}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex  justify-content-between flex-column ">
                    <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{subsidyToVendorPFMSReportModel ?
                        subsidyToVendorPFMSReportModel.length : 0 }} {{'RECORDS_ADDED'| translate}}
                    </p>
                    <div class="flex  justify-content-between flex-column ">
                        <div class="flex">
                            <div
                                style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_THREE_OR_MORE_DAYS' | translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_BY_ONE_OR_TWO_DAYS' | translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'APPROVED_ON_TIME' | translate}}
                        </div>
                    </div>
                </div>
            </ng-template>

        </p-table>
    </div>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<p-dialog [(visible)]="addDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
    <div class="mi-survey-container">
        <p-card styleClass="p-card-shadow">
            <div class="card dashboardTable">
                <p-table #miSurvey [value]="miSurveyData" [rows]="10" [paginator]="true" [globalFilterFields]="[
                    'Full_Name_in_Recognized_Official_Language',
                    'Full_Name_In_English',
                    'Caste_Description',
                    'GST_NO',
                    'Address_Line_1',
                    'Address_Line_2',
                    'Address_Line_3',
                    'District',
                    'State', 
                    'Country', 
                    'Vendor_Bank_Name', 
                    'Vendor_IFSC_Code',
                    'Vendor_Account_Number', 
                    'Vendor_Pan_Card_No', 
                    'Pincode', 
                    'Scheme_Specific_Id',
                    'Center_Share_Payment_Amount',
                    'State_Share_Payment_Amount',
                    'Remarks',
                    'ChallanNo',
                    'UTR',
                    'CreditedOnDateTime',
                    'Programme_Name',
                    'UserType',
                    'Applicant_type',
                    'MIArea',
                    'CAORemarks',
                    'TopUp',
                    'Total_Area',
                    'Crop_Name',
                    'FarmerType',
                    'Block',
                    'Village',
                    'Aadhar_No',
                    'TopUpPFMSPaymentDate'
                    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
                    currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                    [showCurrentPageReport]="true" [loading]="loading1">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MI_SUBSIDY_TO_VENDOR_LOT' | translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH' | translate}}" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th>
                            <th pSortableColumn="Full_Name_In_English">{{'FULL_NAME_IN_ENGLISH' | translate}}
                                <p-columnFilter type="text" field="Full_Name_In_English" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Full_Name_In_English"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Full_Name_in_Recognized_Official_Language">
                                {{'FULL_NAME_IN_RECOGNIZED_OFFICIAL_LANGUAGE' | translate}}
                                <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language"
                                    display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Caste_Description">
                                {{'CASTE' | translate}}
                                <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                                <p-sortIcon field="Caste_Description"></p-sortIcon>
                            </th>
                            <th pSortableColumn="GST_NO">{{'GST_NO' | translate}}
                                <p-columnFilter type="text" field="GST_NO" display="menu"></p-columnFilter>
                                <p-sortIcon field="GST_NO"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_1">{{'ADDRESSLINE1' | translate}}
                                <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_1"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_2">{{'ADDRESSLINE2' | translate}}
                                <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_2"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Address_Line_3">{{'ADDRESSLINE3' | translate}}
                                <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                                <p-sortIcon field="Address_Line_3"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Village">{{'Village' | translate}}
                                <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                                <p-sortIcon field="Village"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Block">{{'BLOCK' | translate}}
                                <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                                <p-sortIcon field="Block"></p-sortIcon>
                            </th>
                            <th pSortableColumn="District">{{'DISTRICT' | translate}}
                                <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                                <p-sortIcon field="District"></p-sortIcon>
                            </th>
                            <th pSortableColumn="State">{{'STATE' | translate}}
                                <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                                <p-sortIcon field="State"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Country">{{'COUNTRY' | translate}}
                                <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                                <p-sortIcon field="Country"></p-sortIcon>
                            </th>
                            <th pSortableColumn="FarmerType">{{'FARMER_TYPE' | translate}}
                                <p-columnFilter type="text" field="FarmerType" display="menu"></p-columnFilter>
                                <p-sortIcon field="FarmerType"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Bank_Name">{{'VENDOR_BANK_NAME' | translate}}
                                <p-columnFilter type="text" field="Vendor_Bank_Name" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_Bank_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_IFSC_Code">{{'VENDOR_IFSCCODE' | translate}}
                                <p-columnFilter type="text" field="Vendor_IFSC_Code" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_IFSC_Code"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Account_Number">{{'VENDOR_ACCOUNT_NUMBER' | translate}}
                                <p-columnFilter type="text" field="Vendor_Account_Number" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Vendor_Account_Number"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Vendor_Pan_Card_No">{{'VENDOR_PAN_CARD_NO' | translate}}
                                <p-columnFilter type="text" field="Vendor_Pan_Card_No" display="menu"></p-columnFilter>
                                <p-sortIcon field="Vendor_Pan_Card_No"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Aadhar_No">{{'AADHAR_NUMBER' | translate}}
                                <p-columnFilter type="text" field="Aadhar_No" display="menu"></p-columnFilter>
                                <p-sortIcon field="Aadhar_No"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Pincode">{{'PINCODE' | translate}}
                                <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                                <p-sortIcon field="Pincode"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID' | translate}}
                                <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                                <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ChallanNo">{{'CHALLAN_NO' | translate}}
                                <p-columnFilter type="text" field="ChallanNo" display="menu"></p-columnFilter>
                                <p-sortIcon field="ChallanNo"></p-sortIcon>
                            </th>
                            <th pSortableColumn="UTR">{{'UTR' | translate}}
                                <p-columnFilter type="text" field="UTR" display="menu"></p-columnFilter>
                                <p-sortIcon field="UTR"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CreditedOnDateTime">{{'CREDITED_DATE' | translate}}
                                <p-columnFilter type="text" field="CreditedOnDateTime" display="menu"></p-columnFilter>
                                <p-sortIcon field="CreditedOnDateTime"></p-sortIcon>
                            </th>
                            <!-- <th pSortableColumn="Programme_Name">{{'MI_TYPE' | translate}}
                                <p-columnFilter type="text" field="Programme_Name" display="menu"></p-columnFilter>
                                <p-sortIcon field="Programme_Name"></p-sortIcon>
                            </th> -->
                            <th pSortableColumn="Center_Share_Payment_Amount">{{'CENTER_SHARE_PAYMENT_AMOUNT' |
                                translate}}
                                <p-columnFilter type="text" field="Center_Share_Payment_Amount" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Center_Share_Payment_Amount"></p-sortIcon>
                            </th>
                            <th pSortableColumn="State_Share_Payment_Amount">{{'STATE_SHARE_PAYMENT_AMOUNT' |
                                translate}}
                                <p-columnFilter type="text" field="State_Share_Payment_Amount" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TopUp">{{'TOP_UP' | translate}}
                                <p-columnFilter type="text" field="TopUp" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="TopUp"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Programme_Name">{{'PROGRAMME_NAME' | translate}}
                                <p-columnFilter type="text" field="Programme_Name" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Programme_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Crop_Name">{{'CROP_NAME' | translate}}
                                <p-columnFilter type="text" field="Crop_Name" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Crop_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="UserType">{{'USER_TYPE' | translate}}
                                <p-columnFilter type="text" field="UserType" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="UserType"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Applicant_type">{{'APPLICATION_TYPE' | translate}}
                                <p-columnFilter type="text" field="Applicant_type" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Applicant_type"></p-sortIcon>
                            </th>
                            <th pSortableColumn="MIArea">{{'MIAREA' | translate}}
                                <p-columnFilter type="text" field="MIArea" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="MIArea"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Total_Area">{{'TOTAL_LAND_HOLDING' | translate}}
                                <p-columnFilter type="Total_Area" field="Total_Area" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="MIArea"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Remarks">{{'REMARKS' | translate}}
                                <p-columnFilter type="text" field="Remarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="Remarks"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CAORemarks">{{'CAO_REMARKS' | translate}}
                                <p-columnFilter type="text" field="CAORemarks" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="CAORemarks"></p-sortIcon>
                            </th>
                            <th pSortableColumn="TopUpPFMSPaymentDate">{{'TOP_UP_PFMS_PAYMENT_DATE'| translate}}
                                <p-columnFilter type="text" field="TopUpPFMSPaymentDate" display="menu">
                                </p-columnFilter>
                                <p-sortIcon field="TopUpPFMSPaymentDate"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>
                                <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectFarmerApplication(product)"></button>
                            </td>
                            <td>{{product?.Full_Name_In_English}}</td>
                            <td>{{product?.Farmer_Name_In_English}}</td>
                            <td>{{product?.Caste_Description}}</td>
                            <td>{{product?.GST_NO}}</td>
                            <td>{{product?.Address_Line_1}}</td>
                            <td>{{product?.Address_Line_2}}</td>
                            <td>{{product?.Address_Line_3}}</td>
                            <td>{{product?.Village}}</td>
                            <td>{{product?.Block}}</td>
                            <td>{{product?.District}}</td>
                            <td>{{product?.State}}</td>
                            <td>{{product?.Country}}</td>
                            <td>{{product?.FarmerType}}</td>
                            <td>{{product?.Vendor_Bank_Name}}</td>
                            <td>{{product?.Vendor_IFSC_Code}}</td>
                            <td>{{product?.Vendor_Account_Number}}</td>
                            <td>{{product?.Vendor_Pan_Card_No}}</td>
                            <td>{{product?.Aadhar_No}}</td>
                            <td>{{product?.Pincode}}</td>
                            <td>{{product?.Scheme_Specific_Id}}</td>
                            <td>{{product?.ChallanNo}}</td>
                            <td>{{product?.UTR}}</td>
                            <td>{{product?.CreditedOnDateTime | date:'mediumDate'}}</td>
                            <!-- <td>{{product?.Programme_Name}}</td> -->
                            <td>{{product?.Center_Share_Payment_Amount}}</td>
                            <td>{{product?.State_Share_Payment_Amount}}</td>
                            <td>{{product?.TopUp}}</td>
                            <td>{{product?.Programme_Name}}</td>
                            <td>{{product?.Crop_Name}}</td>
                            <td>{{product?.UserType}}</td>
                            <td>{{product?.Applicant_type}}</td>
                            <td>{{product?.MIArea}}</td>
                            <td>{{product?.Total_Area}}</td>
                            <td>{{product?.Remarks}}</td>
                            <td>{{product?.CAORemarks}}</td>
                            <td>{{product?.TopUpPFMSPaymentDate}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex  justify-content-between flex-column ">
                            <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }}
                                {{'MI_FARMER_SHARE_TO_VENDOR_LOT_APPLICATIONS_ADDED' | translate}}
                            </p>
                            <div class="flex  justify-content-between flex-column ">
                                <div class="flex">
                                    <div
                                        style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                    </div>{{'PENDING_TWO_OR_MORE_DAYS' | translate}}
                                </div>
                                <div class="flex">
                                    <div
                                        style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                    </div>{{'PENDING_BY_ONE_DAY' | translate}}
                                </div>
                                <div class="flex">
                                    <div
                                        style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                    </div>{{'APROVED_ON_TIME' | translate}}
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-table>
            </div>
            <div class="card">
                <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_FILTERED_FOR_MI_SUBSIDY_TO_VENDOR_LOT' | translate}}: {{
                        miSurveyData?.length }}</b>
                </h5>
                <!-- <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Farmer Amount: {{ totalSubToFarmer }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Subsidy To Vendor Amount: {{ totalSubToVendor }}</p>
                    </div>
                    <div class="field col-12 md:col-4">
                        <p>Total Farmer Refund Amount: {{ totalFarmerRefund }}</p>
                    </div>
                </div> -->
                <div class="flex justify-content-end">
                    <button (click)="menu.toggle($event)" pButton pRipple p-button-info
                        label="Download Filtered Lot Data" icon="pi pi-upload"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"
                        styleClass="prime-slider-override"></p-menu>
                </div>

                <!-- <div class="card">
                    <p-toolbar *ngIf="filteredData.length">
                        <ng-template pTemplate="left">

                        </ng-template>
                        <ng-template pTemplate="right">
                            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                class="mr-3">
                            </p-dropdown>
                            <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea
                                required rows="3" cols="20" class="mr-3"></textarea>
                            <button pButton pRipple label="Submit" (click)="handleClick()"
                                class="p-button-help"></button>
                        </ng-template>
                    </p-toolbar>
                </div> -->
            </div>

        </p-card>
    </div>
</p-dialog>